export default __webpack_public_path__ + "static/resources-33d5cc4a4ef74dda0770b6d54866629b.png";